export default __webpack_public_path__ + "static/media/Calabrese-Small.e12656a2.jpg";